import { Router } from "@angular/router";

export const toollist =  [
    {
        "Type": "Button",
        "Label": "Mode d'emploi",
        "Color": "danger",
        "Icon": "help",
        "Method": "toggleManual"
    }
]